import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: string;
  color?: string;
}

const icons: Record<string, (props: React.SVGProps<SVGSVGElement>, color?: string) => JSX.Element> =
  {
    home: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.21842 7.64082C1.04862 7.30121 1.18627 6.88824 1.52588 6.71844L10.4466 2.25809C10.795 2.08389 11.205 2.08389 11.5534 2.25809L20.4741 6.71844C20.8137 6.88824 20.9514 7.30121 20.7816 7.64082C20.6118 7.98043 20.1988 8.11808 19.8592 7.94828L11 3.51867L2.1408 7.94828C1.80119 8.11808 1.38823 7.98043 1.21842 7.64082Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.66667 9.39586C4.04637 9.39586 4.35417 9.70366 4.35417 10.0834V17.4167C4.35417 18.0495 4.86718 18.5625 5.50001 18.5625H16.5C17.1328 18.5625 17.6458 18.0495 17.6458 17.4167V10.0834C17.6458 9.70366 17.9536 9.39586 18.3333 9.39586C18.713 9.39586 19.0208 9.70366 19.0208 10.0834V17.4167C19.0208 18.8089 17.8922 19.9375 16.5 19.9375H5.50001C4.10779 19.9375 2.97917 18.8089 2.97917 17.4167V10.0834C2.97917 9.70366 3.28698 9.39586 3.66667 9.39586Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    refer: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.32782 3.31061C9.32782 2.11506 10.297 1.14587 11.4926 1.14587C12.6881 1.14587 13.6573 2.11506 13.6573 3.31061V8.68237C13.6573 9.06207 13.3495 9.36987 12.9698 9.36987C12.5901 9.36987 12.2823 9.06207 12.2823 8.68237V3.31061C12.2823 2.87445 11.9287 2.52087 11.4926 2.52087C11.0564 2.52087 10.7028 2.87445 10.7028 3.31061V7.74231C10.7028 8.12201 10.395 8.42981 10.0153 8.42981C9.63563 8.42981 9.32782 8.12201 9.32782 7.74231V3.31061Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5259 4.13039C13.845 2.98709 15.0337 2.32193 16.175 2.64802C17.3219 2.97572 17.9795 4.17795 17.6368 5.32049L15.6423 11.9686C15.5332 12.3322 15.15 12.5386 14.7863 12.4295C14.4226 12.3204 14.2162 11.9371 14.3253 11.5735L16.3197 4.92539C16.4423 4.51699 16.2072 4.08725 15.7972 3.97011C15.3893 3.85355 14.9644 4.09131 14.8503 4.49999L13.6316 8.86704C13.5296 9.23276 13.1503 9.4465 12.7846 9.34444C12.4189 9.24237 12.2052 8.86316 12.3072 8.49744L13.5259 4.13039Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.66427 9.97584C3.17434 8.88907 3.65526 7.61072 4.74003 7.11637C5.83106 6.61915 7.11842 7.10347 7.61118 8.19652L8.57876 10.3428C9.06869 11.4296 8.58776 12.7079 7.503 13.2023C6.41196 13.6995 5.12461 13.2152 4.63185 12.1221L3.66427 9.97584ZM6.93279 11.9511C7.32853 11.7708 7.50398 11.3044 7.32525 10.9079L6.35767 8.76162C6.1779 8.36286 5.70826 8.18617 5.31023 8.36757C4.91449 8.54791 4.73904 9.01427 4.91778 9.41074L5.88536 11.557C6.06512 11.9558 6.53477 12.1325 6.93279 11.9511Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.45433 9.00296C5.92085 7.92032 6.38796 6.61095 7.48624 6.11044C8.56455 5.61902 9.83689 6.09769 10.3239 7.178L11.3076 9.36007C11.6083 10.027 11.6376 10.7849 11.3893 11.4731C11.2605 11.8302 10.8665 12.0153 10.5093 11.8865C10.1521 11.7576 9.96706 11.3636 10.0959 11.0065C10.223 10.6543 10.208 10.2665 10.0541 9.92516L9.0704 7.7431C8.89638 7.35708 8.44174 7.18604 8.05644 7.36163C7.66401 7.54048 7.49709 8.00834 7.68772 8.39519L7.81205 8.64751C7.97988 8.9881 7.83983 9.40025 7.49924 9.56808C7.15865 9.73591 6.74649 9.59587 6.57866 9.25527L6.45433 9.00296Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.09484 8.39875C4.47448 8.39197 4.78773 8.69423 4.79451 9.07387L4.92877 16.5923C4.92879 16.5935 4.92881 16.5947 4.92883 16.5959L4.92902 16.6066C4.92902 18.3778 6.36475 19.8136 8.13594 19.8136H8.40453V21.1886H8.13594C5.60748 21.1886 3.55736 19.1406 3.55392 16.613L3.41973 9.09842C3.41295 8.71878 3.71521 8.40553 4.09484 8.39875ZM14.6252 12.454L14.6274 12.4544C14.6443 12.4576 14.6723 12.4632 14.7093 12.4718C14.7836 12.489 14.8927 12.5175 15.0216 12.5614C15.2843 12.6507 15.605 12.7952 15.8847 13.0164C16.159 13.2332 16.3831 13.5144 16.4924 13.8902C16.6017 14.2663 16.6161 14.8063 16.3497 15.576L16.3342 15.6208C16.0367 16.4801 15.7965 17.1742 15.5603 17.7458C15.3198 18.3278 15.1012 18.7373 14.8666 19.0324C14.6426 19.3139 14.4001 19.4961 14.0887 19.6165C13.7631 19.7423 13.3277 19.8136 12.7019 19.8136H8.40453V21.1886H12.7019C13.4191 21.1886 14.0413 21.1089 14.5844 20.899C15.1418 20.6836 15.5791 20.3454 15.9426 19.8883C16.2955 19.4447 16.5722 18.8974 16.8311 18.2708C17.0829 17.6614 17.3347 16.9338 17.6237 16.0988L17.649 16.0257C17.9869 15.0495 18.0181 14.213 17.8127 13.5064C17.6072 12.7995 17.185 12.2916 16.7375 11.9378C16.2953 11.5882 15.8187 11.3801 15.4644 11.2596C15.2849 11.1986 15.1306 11.1579 15.0187 11.1321C14.9626 11.1191 14.9168 11.1098 14.8832 11.1034C14.8664 11.1002 14.8526 11.0978 14.8422 11.096L14.829 11.0938L14.8243 11.093L14.8224 11.0928C14.8221 11.0927 14.8209 11.0925 14.7163 11.772L14.8209 11.0925L14.8005 11.0894L10.3911 10.6792C9.24824 10.5729 8.23245 11.4054 8.1123 12.5469C8.00636 13.5533 8.63459 14.4917 9.60545 14.7773L12.2566 15.557L12.087 15.8963C11.9172 16.2359 12.0549 16.6488 12.3945 16.8186C12.7341 16.9885 13.1471 16.8508 13.3169 16.5112L13.7679 15.6091C14.0043 15.1363 13.7555 14.5646 13.2483 14.4155L9.99343 13.4581C9.65942 13.3599 9.4433 13.0371 9.47974 12.6908C9.52108 12.2981 9.87054 12.0117 10.2637 12.0483L14.6252 12.454Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    sineWave: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.59821 2.75002C5.5982 2.37032 5.906 2.06251 6.2857 2.0625C7.01075 2.06248 7.60528 2.48515 8.06991 2.99675C8.54177 3.51633 8.9708 4.22569 9.36827 5.02062C10.1603 6.60472 10.908 8.69837 11.6364 10.7379L11.6474 10.7687C12.3888 12.8445 13.1107 14.8627 13.8616 16.3644C14.2375 17.1163 14.6004 17.696 14.948 18.0788C15.3028 18.4696 15.5554 18.5625 15.7143 18.5625C16.094 18.5625 16.4018 18.8703 16.4018 19.25C16.4018 19.6297 16.094 19.9375 15.7143 19.9375C14.9892 19.9375 14.3947 19.5148 13.9301 19.0032C13.4582 18.4836 13.0292 17.7743 12.6317 16.9793C11.8397 15.3952 11.092 13.3016 10.3636 11.2621L10.3526 11.2312C9.6112 9.15542 8.88926 7.1372 8.13843 5.63555C7.76246 4.88361 7.39963 4.30392 7.05202 3.92116C6.69717 3.53043 6.4446 3.4375 6.28573 3.4375C5.90604 3.43751 5.59822 3.12971 5.59821 2.75002Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.29818 5.74341C3.72749 7.25088 3.4375 9.22686 3.4375 11C3.4375 11.3797 3.1297 11.6875 2.75 11.6875C2.3703 11.6875 2.0625 11.3797 2.0625 11C2.0625 9.10647 2.36834 6.95745 3.01224 5.25659C3.33376 4.40731 3.75492 3.62851 4.29972 3.05147C4.8532 2.46523 5.56183 2.0625 6.4167 2.0625C6.79639 2.0625 7.1042 2.3703 7.1042 2.75C7.1042 3.1297 6.79639 3.4375 6.4167 3.4375C6.03405 3.4375 5.66558 3.60768 5.29952 3.99541C4.92478 4.39233 4.58396 4.98852 4.29818 5.74341Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.7018 16.2566C18.2725 14.7491 18.5625 12.7731 18.5625 11C18.5625 10.6203 18.8703 10.3125 19.25 10.3125C19.6297 10.3125 19.9375 10.6203 19.9375 11C19.9375 12.8935 19.6317 15.0425 18.9878 16.7434C18.6662 17.5927 18.2451 18.3715 17.7003 18.9485C17.1468 19.5348 16.4382 19.9375 15.5833 19.9375C15.2036 19.9375 14.8958 19.6297 14.8958 19.25C14.8958 18.8703 15.2036 18.5625 15.5833 18.5625C15.966 18.5625 16.3344 18.3923 16.7005 18.0046C17.0752 17.6077 17.416 17.0115 17.7018 16.2566Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.0625 11C2.0625 10.6203 2.3703 10.3125 2.75 10.3125H4.58333C4.96303 10.3125 5.27083 10.6203 5.27083 11C5.27083 11.3797 4.96303 11.6875 4.58333 11.6875L2.75 11.6875C2.3703 11.6875 2.0625 11.3797 2.0625 11Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.7292 11C16.7292 10.6203 17.037 10.3125 17.4167 10.3125L19.25 10.3125C19.6297 10.3125 19.9375 10.6203 19.9375 11C19.9375 11.3797 19.6297 11.6875 19.25 11.6875H17.4167C17.037 11.6875 16.7292 11.3797 16.7292 11Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5208 11C13.5208 10.6203 13.8286 10.3125 14.2083 10.3125H15.125C15.5047 10.3125 15.8125 10.6203 15.8125 11C15.8125 11.3797 15.5047 11.6875 15.125 11.6875H14.2083C13.8286 11.6875 13.5208 11.3797 13.5208 11Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.1875 11C6.1875 10.6203 6.4953 10.3125 6.875 10.3125H7.79167C8.17136 10.3125 8.47917 10.6203 8.47917 11C8.47917 11.3797 8.17136 11.6875 7.79167 11.6875H6.875C6.4953 11.6875 6.1875 11.3797 6.1875 11Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    notes: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.64585 12.8333C6.64585 12.4536 6.95366 12.1458 7.33335 12.1458L14.6667 12.1458C15.0464 12.1458 15.3542 12.4536 15.3542 12.8333C15.3542 13.213 15.0464 13.5208 14.6667 13.5208L7.33335 13.5208C6.95366 13.5208 6.64585 13.213 6.64585 12.8333Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.64585 9.16663C6.64585 8.78693 6.95366 8.47913 7.33335 8.47913H9.16669C9.54638 8.47913 9.85419 8.78693 9.85419 9.16663C9.85419 9.54632 9.54638 9.85413 9.16669 9.85413H7.33335C6.95366 9.85413 6.64585 9.54632 6.64585 9.16663Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.64585 16.5C6.64585 16.1203 6.95366 15.8125 7.33335 15.8125H11C11.3797 15.8125 11.6875 16.1203 11.6875 16.5C11.6875 16.8797 11.3797 17.1875 11 17.1875H7.33335C6.95366 17.1875 6.64585 16.8797 6.64585 16.5Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.16669 0.229126C9.54638 0.229126 9.85419 0.53693 9.85419 0.916626V4.58329C9.85419 4.96299 9.54638 5.27079 9.16669 5.27079C8.78699 5.27079 8.47919 4.96299 8.47919 4.58329V3.43746H5.50002C4.86719 3.43746 4.35419 3.95047 4.35419 4.58329V18.3333C4.35419 18.9661 4.86719 19.4791 5.50002 19.4791H16.5C17.1328 19.4791 17.6459 18.9661 17.6459 18.3333V4.58329C17.6459 3.95047 17.1328 3.43746 16.5 3.43746H13.2917C12.912 3.43746 12.6042 3.12966 12.6042 2.74996C12.6042 2.37026 12.912 2.06246 13.2917 2.06246H16.5C17.8922 2.06246 19.0209 3.19108 19.0209 4.58329V18.3333C19.0209 19.7255 17.8922 20.8541 16.5 20.8541H5.50002C4.1078 20.8541 2.97919 19.7255 2.97919 18.3333V4.58329C2.97919 3.19108 4.1078 2.06246 5.50002 2.06246H8.47919V0.916626C8.47919 0.53693 8.78699 0.229126 9.16669 0.229126Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    creditCard: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.14581 6.41671C1.14581 5.02449 2.27443 3.89587 3.66665 3.89587H18.3333C19.7255 3.89587 20.8541 5.02449 20.8541 6.41671V15.5834C20.8541 16.9756 19.7255 18.1042 18.3333 18.1042H3.66665C2.27443 18.1042 1.14581 16.9756 1.14581 15.5834V6.41671ZM3.66665 5.27087C3.03382 5.27087 2.52081 5.78388 2.52081 6.41671V15.5834C2.52081 16.2162 3.03382 16.7292 3.66665 16.7292H18.3333C18.9661 16.7292 19.4791 16.2162 19.4791 15.5834V8.93754H5.49998C5.12028 8.93754 4.81248 8.62974 4.81248 8.25004C4.81248 7.87034 5.12028 7.56254 5.49998 7.56254H19.4791V6.41671C19.4791 5.78388 18.9661 5.27087 18.3333 5.27087H3.66665Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    star: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.9215 2.99931C10.9035 3.00988 10.8847 3.02673 10.8686 3.05911L8.48758 7.85531C8.38721 8.05747 8.19402 8.19749 7.97066 8.22995L2.64588 9.0038C2.52203 9.0218 2.48391 9.16489 2.56441 9.24285L6.4167 12.9735C6.57999 13.1317 6.65456 13.3603 6.61592 13.5843L5.70677 18.8548C5.70071 18.8899 5.70598 18.9135 5.71367 18.9312C5.72253 18.9516 5.73894 18.9733 5.76336 18.9909C5.78776 19.0086 5.81444 19.018 5.83861 19.0202C5.86 19.0222 5.88635 19.0195 5.91981 19.002L10.6815 16.5122C10.881 16.4079 11.119 16.4079 11.3186 16.5122L16.0802 19.002C16.1137 19.0195 16.1401 19.0222 16.1614 19.0202C16.1856 19.018 16.2123 19.0086 16.2367 18.9909C16.2611 18.9733 16.2775 18.9516 16.2864 18.9312C16.2941 18.9135 16.2993 18.8899 16.2933 18.8548L15.3841 13.5843C15.3455 13.3603 15.4201 13.1317 15.5833 12.9735L19.4356 9.24285C19.5161 9.1649 19.478 9.0218 19.3542 9.0038L14.0294 8.22995C13.806 8.19749 13.6128 8.05747 13.5125 7.85531L11.1314 3.05911C11.1153 3.02673 11.0965 3.00988 11.0786 2.99931C11.0582 2.98727 11.0309 2.97913 11 2.97913C10.9691 2.97913 10.9419 2.98727 10.9215 2.99931ZM9.63705 2.4477C10.1954 1.32294 11.8046 1.32294 12.363 2.4477L14.5838 6.92108L19.5519 7.64309C20.7945 7.82367 21.3009 9.35054 20.3922 10.2306L16.8009 13.7085L17.6483 18.621C17.8634 19.8679 16.551 20.7998 15.4431 20.2205L11 17.8973L6.55693 20.2205C5.44908 20.7998 4.13669 19.8679 4.35178 18.621L5.19918 13.7085L1.60785 10.2306C0.699124 9.35055 1.20559 7.82367 2.44813 7.64309L7.41625 6.92108L9.63705 2.4477Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    wallet: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill='none'
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.0625 8.25006C2.0625 6.85784 3.19112 5.72922 4.58333 5.72922H17.4167C18.8089 5.72922 19.9375 6.85784 19.9375 8.25006V16.5001C19.9375 17.8923 18.8089 19.0209 17.4167 19.0209H4.58333C3.19112 19.0209 2.0625 17.8923 2.0625 16.5001V8.25006ZM4.58333 7.10422C3.95051 7.10422 3.4375 7.61723 3.4375 8.25006V16.5001C3.4375 17.1329 3.95051 17.6459 4.58333 17.6459H17.4167C18.0495 17.6459 18.5625 17.1329 18.5625 16.5001V8.25006C18.5625 7.61723 18.0495 7.10422 17.4167 7.10422H4.58333Z'
          fill='#ECBC21'
        />
        <path
          d='M15.125 12.8334C14.8719 12.8334 14.6667 12.6282 14.6667 12.3751C14.6667 12.1219 14.8719 11.9167 15.125 11.9167C15.3781 11.9167 15.5833 12.1219 15.5833 12.3751C15.5833 12.6282 15.3781 12.8334 15.125 12.8334Z'
          fill='#ECBC21'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.125 12.6042C14.9984 12.6042 14.8958 12.5016 14.8958 12.3751C14.8958 12.2485 14.9984 12.1459 15.125 12.1459C15.2516 12.1459 15.3542 12.2485 15.3542 12.3751C15.3542 12.5016 15.2516 12.6042 15.125 12.6042ZM16.2708 12.3751C16.2708 11.7422 15.7578 11.2292 15.125 11.2292C14.4922 11.2292 13.9792 11.7422 13.9792 12.3751C13.9792 13.0079 14.4922 13.5209 15.125 13.5209C15.7578 13.5209 16.2708 13.0079 16.2708 12.3751Z'
          fill='#ECBC21'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.8125 5.13635C15.8125 4.3835 15.0989 3.83522 14.3714 4.0292L4.28809 6.71809C3.7865 6.85185 3.4375 7.30611 3.4375 7.82523V8.25006H2.0625V7.82523C2.0625 6.68317 2.83031 5.68378 3.93381 5.38952L14.0171 2.70063C15.6175 2.27387 17.1875 3.48008 17.1875 5.13635V6.41672H15.8125V5.13635Z'
          fill='#ECBC21'
        />
      </svg>
    ),
    sideWallet: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.0625 8.25006C2.0625 6.85784 3.19112 5.72922 4.58333 5.72922H17.4167C18.8089 5.72922 19.9375 6.85784 19.9375 8.25006V16.5001C19.9375 17.8923 18.8089 19.0209 17.4167 19.0209H4.58333C3.19112 19.0209 2.0625 17.8923 2.0625 16.5001V8.25006ZM4.58333 7.10422C3.95051 7.10422 3.4375 7.61723 3.4375 8.25006V16.5001C3.4375 17.1329 3.95051 17.6459 4.58333 17.6459H17.4167C18.0495 17.6459 18.5625 17.1329 18.5625 16.5001V8.25006C18.5625 7.61723 18.0495 7.10422 17.4167 7.10422H4.58333Z'
          fill='#0E0E0B'
        />
        <path
          d='M15.125 12.8334C14.8719 12.8334 14.6667 12.6282 14.6667 12.3751C14.6667 12.1219 14.8719 11.9167 15.125 11.9167C15.3781 11.9167 15.5833 12.1219 15.5833 12.3751C15.5833 12.6282 15.3781 12.8334 15.125 12.8334Z'
          fill='#0E0E0B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.125 12.6042C14.9984 12.6042 14.8958 12.5016 14.8958 12.3751C14.8958 12.2485 14.9984 12.1459 15.125 12.1459C15.2516 12.1459 15.3542 12.2485 15.3542 12.3751C15.3542 12.5016 15.2516 12.6042 15.125 12.6042ZM16.2708 12.3751C16.2708 11.7422 15.7578 11.2292 15.125 11.2292C14.4922 11.2292 13.9792 11.7422 13.9792 12.3751C13.9792 13.0079 14.4922 13.5209 15.125 13.5209C15.7578 13.5209 16.2708 13.0079 16.2708 12.3751Z'
          fill='#0E0E0B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.8125 5.13635C15.8125 4.3835 15.0989 3.83522 14.3714 4.0292L4.28809 6.71809C3.7865 6.85185 3.4375 7.30611 3.4375 7.82523V8.25006H2.0625V7.82523C2.0625 6.68317 2.83031 5.68378 3.93381 5.38952L14.0171 2.70063C15.6175 2.27387 17.1875 3.48008 17.1875 5.13635V6.41672H15.8125V5.13635Z'
          fill='#0E0E0B'
        />
      </svg>
    ),

    user: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 2.52087C6.31709 2.52087 2.52084 6.31713 2.52084 11C2.52084 12.7713 3.06393 14.4157 3.99269 15.7758C4.28931 15.5224 4.6971 15.2179 5.22578 14.9158C6.46608 14.2069 8.35432 13.5209 11 13.5209C13.6457 13.5209 15.534 14.2069 16.7743 14.9158C17.3029 15.2179 17.7107 15.5224 18.0073 15.7758C18.9361 14.4157 19.4792 12.7713 19.4792 11C19.4792 6.31713 15.6829 2.52087 11 2.52087ZM18.6257 17.2417C20.0184 15.5422 20.8542 13.3687 20.8542 11C20.8542 5.55773 16.4423 1.14587 11 1.14587C5.5577 1.14587 1.14584 5.55773 1.14584 11C1.14584 13.3694 1.98205 15.5435 3.37546 17.2432C3.38071 17.2498 3.38609 17.2564 3.3916 17.2628C5.19896 19.456 7.93619 20.8542 11 20.8542C14.0632 20.8542 16.7999 19.4566 18.6072 17.2642C18.6136 17.2568 18.6197 17.2493 18.6257 17.2417ZM17.1423 16.8454C16.9042 16.6392 16.5575 16.3756 16.092 16.1095C15.0502 15.5141 13.396 14.8959 11 14.8959C8.60407 14.8959 6.94983 15.5141 5.90807 16.1095C5.44255 16.3756 5.09578 16.6392 4.85769 16.8454C6.40224 18.4679 8.58302 19.4792 11 19.4792C13.417 19.4792 15.5978 18.4679 17.1423 16.8454ZM4.45387 17.244C4.45387 17.244 4.45388 17.244 4.45388 17.244ZM11 6.18754C9.86092 6.18754 8.9375 7.11095 8.9375 8.25004C8.9375 9.38913 9.86092 10.3125 11 10.3125C12.1391 10.3125 13.0625 9.38913 13.0625 8.25004C13.0625 7.11095 12.1391 6.18754 11 6.18754ZM7.5625 8.25004C7.5625 6.35156 9.10152 4.81254 11 4.81254C12.8985 4.81254 14.4375 6.35156 14.4375 8.25004C14.4375 10.1485 12.8985 11.6875 11 11.6875C9.10152 11.6875 7.5625 10.1485 7.5625 8.25004Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    dollar: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 2.0625C11.3797 2.0625 11.6875 2.3703 11.6875 2.75V4.4128C13.0435 4.59437 14.4246 5.20233 15.2938 6.07154C15.5623 6.34002 15.5623 6.77532 15.2938 7.04381C15.0253 7.31229 14.59 7.31229 14.3215 7.04381C13.5958 6.3181 12.2421 5.76685 10.9815 5.73292C10.2394 5.71295 9.6189 5.87487 9.20073 6.19161C8.81129 6.48658 8.51444 6.97719 8.51444 7.82691C8.51444 8.19252 8.59663 8.45495 8.71723 8.657C8.84021 8.86303 9.02606 9.04431 9.28679 9.21022C9.83567 9.55951 10.5965 9.77346 11.4982 10.0194C11.517 10.0245 11.5358 10.0296 11.5547 10.0348C12.3853 10.2612 13.3429 10.5222 14.086 10.9951C14.4798 11.2456 14.8393 11.57 15.0981 12.0036C15.3592 12.4411 15.4952 12.9521 15.4952 13.5384C15.4952 14.85 14.9201 15.8358 14.0294 16.4596C13.3557 16.9313 12.5306 17.1781 11.6875 17.2452V19.2499C11.6875 19.6296 11.3797 19.9374 11 19.9374C10.6203 19.9374 10.3125 19.6296 10.3125 19.2499V17.202C8.90352 17.0059 7.48647 16.3457 6.64233 15.2201C6.41451 14.9164 6.47608 14.4855 6.77983 14.2576C7.08359 14.0298 7.51451 14.0914 7.74233 14.3951C8.40124 15.2737 9.69838 15.8384 11.0247 15.8861C11.895 15.9173 12.6872 15.7208 13.2406 15.3333C13.7663 14.9651 14.1202 14.3985 14.1202 13.5384C14.1202 13.1728 14.038 12.9104 13.9174 12.7083C13.7944 12.5023 13.6086 12.321 13.3478 12.1551C12.799 11.8058 12.0382 11.5919 11.1364 11.3459C11.1177 11.3408 11.0988 11.3357 11.0799 11.3305C10.2493 11.1041 9.29168 10.8431 8.54858 10.3703C8.15486 10.1197 7.79535 9.79528 7.53657 9.36174C7.27541 8.92422 7.13944 8.41321 7.13944 7.82691C7.13944 6.60776 7.59199 5.68522 8.37052 5.09553C8.93168 4.67049 9.61396 4.45474 10.3125 4.3836V2.75C10.3125 2.3703 10.6203 2.0625 11 2.0625Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    building: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.63575 7.73797C9.91797 7.99197 9.94085 8.42667 9.68685 8.7089L9.67768 8.71908C9.42368 9.00131 8.98898 9.02418 8.70675 8.77018C8.42453 8.51618 8.40165 8.08148 8.65565 7.79925L8.66482 7.78907C8.91882 7.50684 9.35352 7.48396 9.63575 7.73797Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.3024 7.73797C13.5846 7.99197 13.6075 8.42667 13.3535 8.7089L13.3443 8.71908C13.0903 9.00131 12.6556 9.02418 12.3734 8.77018C12.0912 8.51618 12.0683 8.08148 12.3223 7.79925L12.3315 7.78907C12.5855 7.50684 13.0202 7.48396 13.3024 7.73797Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.63575 11.4046C9.91797 11.6586 9.94085 12.0933 9.68685 12.3756L9.67768 12.3857C9.42368 12.668 8.98898 12.6909 8.70675 12.4368C8.42453 12.1828 8.40165 11.7481 8.65565 11.4659L8.66482 11.4557C8.91882 11.1735 9.35352 11.1506 9.63575 11.4046Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.3024 11.4046C13.5846 11.6586 13.6075 12.0933 13.3535 12.3756L13.3443 12.3857C13.0903 12.668 12.6556 12.6909 12.3734 12.4368C12.0912 12.1828 12.0683 11.7481 12.3223 11.4659L12.3315 11.4557C12.5855 11.1735 13.0202 11.1506 13.3024 11.4046Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.63575 15.0713C9.91797 15.3253 9.94085 15.76 9.68685 16.0422L9.67768 16.0524C9.42368 16.3346 8.98898 16.3575 8.70675 16.1035C8.42453 15.8495 8.40165 15.4148 8.65565 15.1326L8.66482 15.1224C8.91882 14.8402 9.35352 14.8173 9.63575 15.0713Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.3024 15.0713C13.5846 15.3253 13.6075 15.76 13.3535 16.0422L13.3443 16.0524C13.0903 16.3346 12.6556 16.3575 12.3734 16.1035C12.0912 15.8495 12.0683 15.4148 12.3223 15.1326L12.3315 15.1224C12.5855 14.8402 13.0202 14.8173 13.3024 15.0713Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.1875 18.7C17.1875 19.3835 16.6335 19.9375 15.95 19.9375H6.05C5.36655 19.9375 4.8125 19.3835 4.8125 18.7V5.13333C4.8125 4.44988 5.36655 3.89583 6.05 3.89583H10.3125V3.3C10.3125 2.61655 10.8665 2.0625 11.55 2.0625H15.95C16.6335 2.0625 17.1875 2.61655 17.1875 3.3V18.7ZM15.8125 18.5625V3.4375H11.6875V4.58333C11.6875 4.96303 11.3797 5.27083 11 5.27083H6.1875V18.5625H15.8125Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    passwordCursor: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.6875 14.6667C11.6875 15.0464 11.3797 15.3542 11 15.3542H4.58333C3.19112 15.3542 2.0625 14.2256 2.0625 12.8333V7.33333C2.0625 5.94112 3.19112 4.8125 4.58333 4.8125H17.4167C18.8089 4.8125 19.9375 5.94112 19.9375 7.33333V11.9167C19.9375 12.2964 19.6297 12.6042 19.25 12.6042C18.8703 12.6042 18.5625 12.2964 18.5625 11.9167V7.33333C18.5625 6.70051 18.0495 6.1875 17.4167 6.1875H4.58333C3.95051 6.1875 3.4375 6.70051 3.4375 7.33333V12.8333C3.4375 13.4662 3.95051 13.9792 4.58333 13.9792H11C11.3797 13.9792 11.6875 14.287 11.6875 14.6667Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.3488 11.9332C13.7373 11.6611 14.231 11.6811 14.6245 11.9232L19.4992 14.922C19.9465 15.1972 20.1682 15.6762 20.1498 16.1248C20.1307 16.5893 19.8231 17.1262 19.175 17.1997L17.1937 17.4243L16.305 19.2093C16.0143 19.7932 15.4046 19.8986 14.9616 19.7576C14.5338 19.6215 14.1594 19.2494 14.0538 18.7349L12.9031 13.1286C12.8102 12.6759 12.9603 12.2052 13.3488 11.9332ZM14.357 13.373L15.3255 18.0916L16.296 16.1422L18.4598 15.897L14.357 13.373ZM15.4014 18.4604C15.4014 18.4604 15.4015 18.4608 15.4014 18.4604V18.4604Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.4691 9.5713C11.7513 9.8253 11.7742 10.26 11.5202 10.5422L11.511 10.5524C11.257 10.8346 10.8223 10.8575 10.5401 10.6035C10.2579 10.3495 10.235 9.91481 10.489 9.63259L10.4982 9.6224C10.7522 9.34018 11.1869 9.3173 11.4691 9.5713Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.1357 9.5713C15.418 9.8253 15.4409 10.26 15.1868 10.5422L15.1777 10.5524C14.9237 10.8346 14.489 10.8575 14.2068 10.6035C13.9245 10.3495 13.9016 9.91481 14.1557 9.63259L14.1648 9.6224C14.4188 9.34018 14.8535 9.3173 15.1357 9.5713Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.80241 9.5713C8.08464 9.8253 8.10752 10.26 7.85351 10.5422L7.84435 10.5524C7.59034 10.8346 7.15565 10.8575 6.87342 10.6035C6.59119 10.3495 6.56832 9.91481 6.82232 9.63259L6.83149 9.6224C7.08549 9.34018 7.52019 9.3173 7.80241 9.5713Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    shieldAlert: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11 5.72916C11.3797 5.72916 11.6875 6.03697 11.6875 6.41666V11C11.6875 11.3797 11.3797 11.6875 11 11.6875C10.6203 11.6875 10.3125 11.3797 10.3125 11V6.41666C10.3125 6.03697 10.6203 5.72916 11 5.72916Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.4691 14.1546C11.7513 14.4086 11.7742 14.8433 11.5202 15.1256L11.511 15.1357C11.257 15.418 10.8223 15.4408 10.5401 15.1868C10.2579 14.9328 10.235 14.4981 10.489 14.2159L10.4982 14.2057C10.7522 13.9235 11.1869 13.9006 11.4691 14.1546Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4532 1.25058C10.8133 1.17054 11.1867 1.17054 11.5468 1.25058L18.5705 2.81139C19.3851 2.99242 19.9302 3.7669 19.8111 4.60037L18.0973 16.5972C18.0554 16.8904 17.9038 17.8875 16.8713 18.7916C15.8507 19.6852 14.0762 20.3958 11 20.3958C7.92381 20.3958 6.14929 19.6852 5.1287 18.7916C4.09623 17.8875 3.94463 16.8904 3.90274 16.5972L2.18891 4.60037C2.06984 3.7669 2.61485 2.99242 3.42951 2.81139L10.4532 1.25058ZM11.2486 2.59284C11.0849 2.55646 10.9151 2.55646 10.7514 2.59284L3.72779 4.15365C3.60727 4.18043 3.53368 4.29103 3.55009 4.40592L5.26496 16.4101C5.28924 16.581 5.37418 17.1789 6.03449 17.7571C6.71645 18.3542 8.11786 19.0208 11 19.0208C13.8821 19.0208 15.2835 18.3542 15.9655 17.7571C16.6258 17.1789 16.7108 16.581 16.735 16.4101L18.4499 4.40592C18.4663 4.29103 18.3927 4.18043 18.2722 4.15365L11.2486 2.59284Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    signOut: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.9028 10.5139C18.1713 10.7823 18.1713 11.2177 17.9028 11.4861L15.1528 14.2361C14.8843 14.5046 14.449 14.5046 14.1805 14.2361C13.912 13.9677 13.912 13.5323 14.1805 13.2639L15.7569 11.6875H11C10.6203 11.6875 10.3125 11.3797 10.3125 11C10.3125 10.6203 10.6203 10.3125 11 10.3125H15.7569L14.1805 8.73614C13.912 8.46765 13.912 8.03235 14.1805 7.76386C14.449 7.49538 14.8843 7.49538 15.1528 7.76386L17.9028 10.5139Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.41667 3.4375C5.78384 3.4375 5.27084 3.95051 5.27084 4.58333V17.4167C5.27084 18.0495 5.78384 18.5625 6.41667 18.5625H15.5833C16.2162 18.5625 16.7292 18.0495 16.7292 17.4167V16.5C16.7292 16.1203 17.037 15.8125 17.4167 15.8125C17.7964 15.8125 18.1042 16.1203 18.1042 16.5V17.4167C18.1042 18.8089 16.9756 19.9375 15.5833 19.9375H6.41667C5.02445 19.9375 3.89584 18.8089 3.89584 17.4167V4.58333C3.89584 3.19112 5.02445 2.0625 6.41667 2.0625H15.5833C16.9756 2.0625 18.1042 3.19112 18.1042 4.58333V5.5C18.1042 5.8797 17.7964 6.1875 17.4167 6.1875C17.037 6.1875 16.7292 5.8797 16.7292 5.5V4.58333C16.7292 3.95051 16.2162 3.4375 15.5833 3.4375H6.41667Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    refreshDouble: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='14'
        viewBox='0 0 14 14'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <g clipPath='url(#clip0_2644_5942)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.99988 1.60413C4.20221 1.60413 1.90138 3.73363 1.63071 6.45985C1.60683 6.70029 1.39256 6.87586 1.15212 6.85198C0.911679 6.82811 0.736115 6.61384 0.759987 6.3734C1.07466 3.20408 3.74797 0.729126 6.99988 0.729126C9.572 0.729126 11.7815 2.27764 12.7487 4.49146C12.8455 4.71288 12.7444 4.97079 12.523 5.06753C12.3016 5.16427 12.0437 5.0632 11.9469 4.84179C11.1139 2.93517 9.21183 1.60413 6.99988 1.60413Z'
            fill={color || 'currentColor'}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.8332 1.31246C13.0748 1.31246 13.2707 1.50833 13.2707 1.74996V4.31663C13.2707 4.75155 12.9181 5.10413 12.4832 5.10413H9.91654C9.67492 5.10413 9.47904 4.90825 9.47904 4.66663C9.47904 4.425 9.67492 4.22913 9.91654 4.22913H12.3957V1.74996C12.3957 1.50833 12.5916 1.31246 12.8332 1.31246Z'
            fill={color || 'currentColor'}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.02868 12.3958C9.82634 12.3958 12.1272 10.2663 12.3979 7.54007C12.4217 7.29962 12.636 7.12406 12.8764 7.14793C13.1169 7.17181 13.2924 7.38608 13.2686 7.62652C12.9539 10.7958 10.2806 13.2708 7.02868 13.2708C4.45656 13.2708 2.24709 11.7223 1.27983 9.50846C1.18309 9.28704 1.28416 9.02913 1.50557 8.93239C1.72698 8.83565 1.9849 8.93672 2.08164 9.15813C2.91467 11.0648 4.81672 12.3958 7.02868 12.3958Z'
            fill={color || 'currentColor'}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1.19531 12.6875C0.953688 12.6875 0.757812 12.4916 0.757812 12.25V9.68329C0.757812 9.24837 1.11039 8.89579 1.54531 8.89579H4.11198C4.3536 8.89579 4.54948 9.09167 4.54948 9.33329C4.54948 9.57492 4.3536 9.77079 4.11198 9.77079H1.63281V12.25C1.63281 12.4916 1.43694 12.6875 1.19531 12.6875Z'
            fill={color || 'currentColor'}
          />
        </g>
        <defs>
          <clipPath id='clip0_2644_5942'>
            <rect width='14' height='14' fill='white' />
          </clipPath>
        </defs>
      </svg>
    ),
    handCash: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='44'
        height='44'
        viewBox='0 0 44 44'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.2916 29.7067C13.2916 31.4087 14.0194 33.0294 15.2915 34.1601L21.0802 39.3055C21.6477 39.8101 21.6989 40.6792 21.1943 41.2467C20.6898 41.8143 19.8207 41.8654 19.2532 41.3609L13.4645 36.2154C11.6053 34.5629 10.5416 32.1942 10.5416 29.7067L10.5416 29.3332C10.5416 28.5738 11.1572 27.9582 11.9166 27.9582C12.676 27.9582 13.2916 28.5738 13.2916 29.3332L13.2916 29.7067Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.7142 16.0265C26.1211 16.2256 27.4709 17.0116 28.5744 18.391C29.4621 19.5007 30.1622 20.4339 30.6419 21.0921C30.8818 21.4212 31.0668 21.6818 31.1927 21.8615C31.2557 21.9513 31.304 22.021 31.337 22.0689L31.3694 22.1163L36.8504 29.4249C37.0289 29.6629 37.1254 29.9524 37.1254 30.2498L37.1259 40.3332C37.1259 41.0926 36.5103 41.7082 35.7509 41.7082C34.9915 41.7083 34.3759 41.0927 34.3759 40.3333L34.3754 30.7082L29.1508 23.7415M29.1121 23.6871L29.1106 23.685L29.1034 23.6744L29.0717 23.6282C29.043 23.5865 28.9992 23.5232 28.9408 23.4399C28.824 23.2732 28.6489 23.0265 28.4196 22.7119C27.9608 22.0825 27.2858 21.1824 26.427 20.1088C25.6972 19.1966 24.9464 18.8367 24.3289 18.7494C23.6996 18.6603 23.0877 18.8357 22.5964 19.2041C21.652 19.9124 21.1049 21.3866 22.2273 23.0707C23.4843 24.9568 24.6405 26.8064 25.4815 28.1827C25.9023 28.8714 26.245 29.4429 26.4828 29.8428C26.6018 30.0428 26.6945 30.1999 26.7578 30.3075L26.8301 30.4308L26.8552 30.4737C27.2373 31.1299 27.0157 31.9727 26.3595 32.3548C25.7032 32.7369 24.8615 32.5147 24.4793 31.8585C24.4793 31.8585 24.4793 31.8585 24.4793 31.8585L24.4566 31.8196L24.3874 31.7016C24.3262 31.5977 24.2357 31.4444 24.1192 31.2485C23.8862 30.8566 23.5492 30.2946 23.1349 29.6165C22.3055 28.2592 21.1695 26.4422 19.939 24.5958C18.0067 21.6965 18.8352 18.5874 20.9465 17.004C21.9831 16.2266 23.3193 15.8291 24.7142 16.0265'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.8333 30.7082C10.0489 30.7082 7.79163 28.451 7.79163 25.6666L7.79162 7.33324C7.79162 4.54881 10.0489 2.29157 12.8333 2.29157L23.8333 2.29157C26.6177 2.29157 28.875 4.5488 28.875 7.33324L28.875 19.2499L26.125 19.2499L26.125 7.33324C26.125 6.06758 25.0989 5.04157 23.8333 5.04157L12.8333 5.04157C11.5676 5.04157 10.5416 6.06758 10.5416 7.33324L10.5416 25.6666C10.5416 26.9322 11.5676 27.9582 12.8333 27.9582L24.75 27.9582L24.75 30.7082L12.8333 30.7082Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.0416 16.4999C16.0416 15.2343 17.0676 14.2082 18.3333 14.2082C19.5989 14.2082 20.625 15.2343 20.625 16.4999C20.625 17.7656 19.5989 18.7916 18.3333 18.7916C17.0676 18.7916 16.0416 17.7656 16.0416 16.4999ZM18.3333 11.4582C15.5489 11.4582 13.2916 13.7155 13.2916 16.4999C13.2916 19.2843 15.5489 21.5416 18.3333 21.5416C21.1177 21.5416 23.375 19.2843 23.375 16.4999C23.375 13.7155 21.1177 11.4582 18.3333 11.4582Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.3092 7.31174C17.8172 6.74729 18.6866 6.70153 19.2511 7.20954L19.2715 7.22787C19.8359 7.73588 19.8817 8.60528 19.3737 9.16973C18.8656 9.73418 17.9962 9.77994 17.4318 9.27193L17.4114 9.2536C16.847 8.74559 16.8012 7.87619 17.3092 7.31174Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.3092 23.8117C17.8172 23.2473 18.6866 23.2015 19.2511 23.7095L19.2715 23.7279C19.8359 24.2359 19.8817 25.1053 19.3737 25.6697C18.8656 26.2342 17.9962 26.2799 17.4318 25.7719L17.4114 25.7536C16.847 25.2456 16.8012 24.3762 17.3092 23.8117Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    cardWallet: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='44'
        height='44'
        viewBox='0 0 44 44'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.5 39.875C13.7156 39.875 11.4583 37.6178 11.4583 34.8333L11.4583 9.16667C11.4583 6.38223 13.7156 4.125 16.5 4.125L33 4.125C35.7844 4.125 38.0417 6.38223 38.0417 9.16667L38.0417 34.8333C38.0417 37.6178 35.7844 39.875 33 39.875L16.5 39.875ZM14.2083 34.8333C14.2083 36.099 15.2343 37.125 16.5 37.125L33 37.125C34.2657 37.125 35.2917 36.099 35.2917 34.8333L35.2917 9.16667C35.2917 7.90102 34.2657 6.875 33 6.875L16.5 6.875C15.2343 6.875 14.2083 7.90102 14.2083 9.16667L14.2083 34.8333Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.6 32.5417C5.23309 32.5417 4.125 31.4336 4.125 30.0667L4.125 13.9333C4.125 12.5664 5.23309 11.4583 6.6 11.4583L12.8333 11.4583L12.8333 14.2083L6.875 14.2083L6.875 29.7917L12.8333 29.7917L12.8333 32.5417L6.6 32.5417Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.8333 27.0417L5.5 27.0417L5.5 24.2917L12.8333 24.2917L12.8333 27.0417Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.8333 23.375L5.5 23.375L5.5 20.625L12.8333 20.625L12.8333 23.375Z'
          fill={color || 'currentColor'}
        />
        <path
          d='M25.6667 13.75C25.6667 14.2563 25.2563 14.6667 24.75 14.6667C24.2437 14.6667 23.8333 14.2563 23.8333 13.75C23.8333 13.2437 24.2437 12.8333 24.75 12.8333C25.2563 12.8333 25.6667 13.2437 25.6667 13.75Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.2083 13.75C25.2083 14.0031 25.0031 14.2083 24.75 14.2083C24.4969 14.2083 24.2917 14.0031 24.2917 13.75C24.2917 13.4969 24.4969 13.2917 24.75 13.2917C25.0031 13.2917 25.2083 13.4969 25.2083 13.75ZM24.75 11.4583C23.4843 11.4583 22.4583 12.4843 22.4583 13.75C22.4583 15.0157 23.4843 16.0417 24.75 16.0417C26.0157 16.0417 27.0417 15.0157 27.0417 13.75C27.0417 12.4843 26.0157 11.4583 24.75 11.4583Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    rocket: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16 2.95787L12.7046 7.17607C11.2891 8.9878 10.8536 11.3791 11.5394 13.5735L14.0685 21.6669H17.9315L20.4607 13.5735C21.1464 11.3791 20.7109 8.98781 19.2955 7.17607L16 2.95787ZM14.5816 1.52485C15.3022 0.602393 16.6978 0.602395 17.4185 1.52485L20.8715 5.94478C22.6914 8.27416 23.2513 11.3486 22.3696 14.1701L19.6212 22.9652C19.4907 23.3826 19.1041 23.6669 18.6667 23.6669H13.3334C12.896 23.6669 12.5093 23.3826 12.3789 22.9652L9.6304 14.1701C8.74871 11.3486 9.30868 8.27416 11.1285 5.94478L14.5816 1.52485Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.5528 31.5613L16 30.6669L16.4472 31.5613C16.1657 31.7021 15.8343 31.7021 15.5528 31.5613ZM16 29.4894C15.8136 29.3559 15.5929 29.1789 15.3738 28.9598C14.8161 28.4021 14.3334 27.6415 14.3334 26.6669C14.3334 26.1146 13.8856 25.6669 13.3334 25.6669C12.7811 25.6669 12.3334 26.1146 12.3334 26.6669C12.3334 28.359 13.1839 29.5983 13.9596 30.374C14.3501 30.7645 14.738 31.0552 15.0287 31.2489C15.1748 31.3464 15.2987 31.4209 15.3893 31.4726C15.4346 31.4985 15.4718 31.5189 15.4995 31.5336L15.5337 31.5516L15.5452 31.5575L15.5495 31.5597L15.5513 31.5606L15.5528 31.5613C15.5532 31.5615 15.5528 31.5613 16 30.6669C16.4472 31.5613 16.4469 31.5615 16.4472 31.5613L16.4488 31.5606L16.4505 31.5597L16.4548 31.5575L16.4663 31.5516L16.5006 31.5336C16.5282 31.5189 16.5654 31.4985 16.6107 31.4726C16.7013 31.4209 16.8252 31.3464 16.9714 31.2489C17.262 31.0552 17.6499 30.7645 18.0405 30.374C18.8161 29.5983 19.6667 28.359 19.6667 26.6669C19.6667 26.1146 19.219 25.6669 18.6667 25.6669C18.1144 25.6669 17.6667 26.1146 17.6667 26.6669C17.6667 27.6415 17.1839 28.4021 16.6262 28.9598C16.4072 29.1789 16.1864 29.3559 16 29.4894Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.43893 25.7808L9.33335 25.3336C8.43893 25.7808 8.43915 25.7812 8.43893 25.7808L8.43797 25.7789L8.43678 25.7765L8.43367 25.7701L8.42469 25.7516C8.41751 25.7367 8.408 25.7167 8.39648 25.6917C8.37343 25.6417 8.34226 25.5719 8.30551 25.4842C8.2321 25.3089 8.13582 25.0604 8.03739 24.7536C7.8416 24.1432 7.63142 23.2834 7.58449 22.2978C7.48911 20.295 8.07844 17.7629 10.7521 15.8532C11.2015 15.5321 11.8261 15.6362 12.1471 16.0857C12.4681 16.5351 12.364 17.1596 11.9146 17.4806C9.9216 18.9042 9.51093 20.7055 9.58222 22.2027C9.6107 22.8007 9.71778 23.3482 9.83889 23.7947L12.7787 21.8348C13.2382 21.5285 13.8591 21.6527 14.1654 22.1122C14.4718 22.5717 14.3476 23.1926 13.8881 23.4989L9.88805 26.1656C9.6494 26.3247 9.35391 26.3737 9.07669 26.3001C8.79946 26.2264 8.5672 26.0373 8.43893 25.7808Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.136 25.7808L23.2416 25.3336C24.136 25.7808 24.1358 25.7812 24.136 25.7808L24.1369 25.7789L24.1381 25.7765L24.1412 25.7701L24.1502 25.7516C24.1574 25.7367 24.1669 25.7167 24.1784 25.6917C24.2015 25.6417 24.2326 25.5719 24.2694 25.4842C24.3428 25.3089 24.4391 25.0604 24.5375 24.7536C24.7333 24.1432 24.9435 23.2834 24.9904 22.2978C25.0858 20.295 24.4965 17.7629 21.8228 15.8532C21.3734 15.5321 20.7488 15.6362 20.4278 16.0857C20.1068 16.5351 20.2109 17.1596 20.6603 17.4806C22.6533 18.9042 23.064 20.7055 22.9927 22.2027C22.9642 22.8007 22.8571 23.3482 22.736 23.7947L19.7963 21.8348C19.3367 21.5285 18.7159 21.6527 18.4095 22.1122C18.1032 22.5717 18.2273 23.1926 18.6869 23.4989L22.6869 26.1656C22.9255 26.3247 23.221 26.3737 23.4982 26.3001C23.7754 26.2264 24.0077 26.0373 24.136 25.7808Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16 10.3336C16.9205 10.3336 17.6667 11.0797 17.6667 12.0002C17.6667 12.9207 16.9205 13.6669 16 13.6669C15.0795 13.6669 14.3334 12.9207 14.3334 12.0002C14.3334 11.0797 15.0795 10.3336 16 10.3336ZM19.6667 12.0002C19.6667 9.97518 18.0251 8.33356 16 8.33356C13.975 8.33356 12.3334 9.97518 12.3334 12.0002C12.3334 14.0253 13.975 15.6669 16 15.6669C18.0251 15.6669 19.6667 14.0253 19.6667 12.0002Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    curlyCheck: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.289 2.82476C14.7435 1.22768 17.2564 1.22769 18.7109 2.82476L20.0712 4.3184C20.4053 4.68529 20.8855 4.88421 21.3812 4.86104L23.3992 4.76673C25.557 4.66589 27.3339 6.44281 27.2331 8.60058L27.1388 10.6186C27.1156 11.1143 27.3145 11.5945 27.6814 11.9286L29.175 13.2889C30.7721 14.7434 30.7721 17.2563 29.175 18.7108L27.6814 20.071C27.3145 20.4052 27.1156 20.8854 27.1388 21.3811L27.2331 23.3991C27.3339 25.5569 25.557 27.3338 23.3992 27.233L21.3812 27.1386C20.8855 27.1155 20.4053 27.3144 20.0712 27.6813L18.7109 29.1749C17.2564 30.772 14.7435 30.772 13.289 29.1749L11.9288 27.6813C11.5946 27.3144 11.1144 27.1155 10.6187 27.1386L8.6007 27.233C6.44293 27.3338 4.66601 25.5569 4.76685 23.3991L4.86117 21.3811C4.88433 20.8854 4.68541 20.4052 4.31852 20.071L2.82488 18.7108C1.22781 17.2563 1.22781 14.7434 2.82488 13.2889L4.31853 11.9286C4.68541 11.5945 4.88433 11.1143 4.86117 10.6186L4.76685 8.60057C4.66601 6.44281 6.44293 4.66589 8.6007 4.76673L10.6187 4.86104C11.1144 4.88421 11.5946 4.68529 11.9288 4.3184L13.289 2.82476ZM17.2322 4.17141C16.5711 3.44547 15.4288 3.44547 14.7677 4.17141L13.4075 5.66505C12.6724 6.47221 11.6159 6.90983 10.5253 6.85886L8.50733 6.76455C7.52653 6.71871 6.71884 7.5264 6.76467 8.50721L6.85898 10.5252C6.90995 11.6157 6.47233 12.6723 5.66518 13.4073L4.17153 14.7676C3.44559 15.4287 3.44559 16.571 4.17153 17.2321L5.66518 18.5924C6.47233 19.3274 6.90995 20.3839 6.85898 21.4745L6.76467 23.4925C6.71884 24.4733 7.52653 25.281 8.50733 25.2351L10.5253 25.1408C11.6159 25.0899 12.6724 25.5275 13.4075 26.3346L14.7677 27.8283C15.4288 28.5542 16.5711 28.5542 17.2322 27.8283L18.5925 26.3346C19.3276 25.5275 20.3841 25.0899 21.4746 25.1408L23.4926 25.2351C24.4734 25.281 25.2811 24.4733 25.2353 23.4925L25.1409 21.4745C25.09 20.3839 25.5276 19.3274 26.3348 18.5924L27.8284 17.2321C28.5543 16.571 28.5543 15.4287 27.8284 14.7676L26.3348 13.4073C25.5276 12.6723 25.09 11.6157 25.1409 10.5252L25.2353 8.50721C25.2811 7.5264 24.4734 6.71871 23.4926 6.76455L21.4746 6.85886C20.3841 6.90983 19.3276 6.47221 18.5925 5.66505L17.2322 4.17141Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.2929 15.2927C11.6834 14.9022 12.3165 14.9022 12.7071 15.2927L14.6666 17.2523L19.2929 12.6261C19.6834 12.2355 20.3166 12.2355 20.7071 12.6261C21.0976 13.0166 21.0976 13.6498 20.7071 14.0403L15.3737 19.3736C14.9832 19.7641 14.35 19.7641 13.9595 19.3736L11.2929 16.707C10.9023 16.3164 10.9023 15.6833 11.2929 15.2927Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    bin: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.16771 3.61236L4.56811 14.1154C4.67975 14.9527 5.17561 15.6899 5.90898 16.109L6.17554 16.2613C8.54534 17.6155 11.4546 17.6155 13.8244 16.2613L14.0909 16.109C14.8243 15.6899 15.3202 14.9527 15.4318 14.1154L16.8322 3.61236C16.228 3.22547 14.3236 2.2915 9.99995 2.2915C5.67633 2.2915 3.77193 3.22547 3.16771 3.61236ZM2.33022 2.66986C3.03983 2.16462 5.16457 1.0415 9.99995 1.0415C14.8353 1.0415 16.9601 2.16462 17.6697 2.66986C18.0165 2.91683 18.1326 3.31744 18.0868 3.66069L16.6708 14.2806C16.5077 15.5043 15.7829 16.5818 14.7111 17.1943L14.4445 17.3466C11.6904 18.9204 8.30945 18.9204 5.55537 17.3466L5.2888 17.1943C4.21696 16.5818 3.49223 15.5043 3.32908 14.2806L1.91309 3.66069C1.86732 3.31744 1.98335 2.91684 2.33022 2.66986Z'
          fill={color || 'currentColor'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.9113 4.31837C3.44913 4.12666 3.13446 3.92411 2.94985 3.73267L2.05005 4.60034C2.40115 4.96445 2.89005 5.24802 3.43235 5.47297C3.98137 5.70071 4.62422 5.88428 5.31945 6.02847C6.70999 6.31688 8.3611 6.45816 9.99995 6.45816C11.6388 6.45815 13.2899 6.31687 14.6804 6.02846C15.3757 5.88427 16.0185 5.7007 16.5675 5.47296C17.1098 5.24801 17.5987 4.96445 17.9498 4.60034L17.05 3.73267C16.8654 3.92411 16.5508 4.12665 16.0886 4.31836C15.6332 4.50728 15.0706 4.67093 14.4266 4.80451C13.1386 5.07166 11.5754 5.20815 9.99995 5.20816C8.42451 5.20816 6.86134 5.07167 5.5733 4.80452C4.92925 4.67094 4.36674 4.50729 3.9113 4.31837Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
    shield: (props: React.SVGProps<SVGSVGElement>, color?: string) => (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='22'
        height='22'
        viewBox='0 0 22 22'
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        {...props}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4532 1.25058C10.8133 1.17054 11.1867 1.17054 11.5468 1.25058L18.5705 2.81139C19.3851 2.99242 19.9302 3.7669 19.8111 4.60037L18.0973 16.5972C18.0554 16.8904 17.9038 17.8875 16.8713 18.7916C15.8507 19.6852 14.0762 20.3958 11 20.3958C7.92381 20.3958 6.14929 19.6852 5.1287 18.7916C4.09623 17.8875 3.94463 16.8904 3.90274 16.5972L2.18891 4.60037C2.06984 3.7669 2.61485 2.99242 3.42951 2.81139L10.4532 1.25058ZM11.2486 2.59284C11.0849 2.55646 10.9151 2.55646 10.7514 2.59284L3.72779 4.15365C3.60727 4.18043 3.53368 4.29103 3.55009 4.40592L5.26496 16.4101C5.28924 16.581 5.37418 17.1789 6.03449 17.7571C6.71645 18.3542 8.11786 19.0208 11 19.0208C13.8821 19.0208 15.2835 18.3542 15.9655 17.7571C16.6258 17.1789 16.7108 16.581 16.735 16.4101L18.4499 4.40592C18.4663 4.29103 18.3927 4.18043 18.2722 4.15365L11.2486 2.59284Z'
          fill={color || 'currentColor'}
        />
      </svg>
    ),
  };

export const Icon = ({ name, color, ...props }: IconProps) => {
  const SvgIcon = icons[name];
  return SvgIcon ? SvgIcon(props, color) : null;
};
